import React, { useState, useEffect } from 'react';
import { Header, SignInForm } from 'widgets';
import { observer } from 'mobx-react';
import { accessTokenStore, userStore } from 'entities/index';
import { Loading } from 'pages/loading/ui/loading.page';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from 'shared/ui';

export const SignInPage: React.FC = observer(() => {
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (accessTokenStore.isAuth) {
      userStore.redirectToRoleBasedPage(navigate);
    }
    setIsReady(true);
  }, [accessTokenStore.isAuth]);

  if (!isReady) {
    return <Loading />;
  }

  return (
    <PageLayout>
      <Header hideSignInButton signUpButtonText="Регистрация" />
      <SignInForm />
    </PageLayout>
  );
});
